<template>
   <dashboard-layout><v-container fluid class="down-top-padding py-0"><BaseBreadcrumb :title="page.title" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
      <v-card><v-toolbar dark color="primary"><v-icon left>mdi-account-arrow-up</v-icon><v-toolbar-title>Corporate Upgrade Information</v-toolbar-title><v-spacer></v-spacer><v-chip small :color="statusColor" dark>{{ statusLabel }}</v-chip></v-toolbar>
         <v-card-text>
            <v-alert v-if="flash.status" type="success" dense text>{{ flash.status }}</v-alert>
            <v-alert v-if="flash.error" type="error" dense text>{{ flash.error }}</v-alert>

            <v-card outlined class="mb-5 applicant"><v-card-text><v-row align="center">
               <v-col cols="12" sm="auto">
                  <v-avatar size="76" color="blue lighten-5">
                     <v-img :src="profilePhotoSrc" :alt="memberinfo.fullname"></v-img>
                  </v-avatar>
               </v-col>
               <v-col cols="12" md="5">
                  <div class="overline">Applicant</div>
                  <div class="text-h6 font-weight-bold">{{ memberinfo.fullname }}</div>
                  <div>{{ memberinfo.contactemail }}</div>
               </v-col>
               <v-col cols="6" md="3">
                  <div class="caption">Member ID</div>
                  <strong>{{ memberinfo.memberid||'-' }}</strong>
               </v-col>
               <v-col cols="6" md="2">
                  <div class="caption">Previous Type</div>
                  <strong>{{ memberinfo.applcorp_previous_membertype||'GRA' }}</strong>
               </v-col>
            </v-row></v-card-text></v-card>

            <v-alert v-if="status===3" type="warning" dense text>
               <strong>Application Rejected.</strong> Admin can reopen this application to allow the member to resubmit.
            </v-alert>

            <!-- Endorsement Status -->
            <v-row v-if="[1,2,4].includes(status)" dense class="mb-4">
               <v-col cols="12" md="6">
                  <v-card outlined><v-card-text class="py-3">
                     <div class="caption grey--text mb-1">Proposer</div>
                     <div class="body-2 font-weight-medium">{{ proposer ? proposer.fullname : 'Not assigned' }}</div>
                     <div v-if="proposer" class="caption grey--text">{{ proposer.memberid || '-' }} ({{ proposer.membertype }})</div>
                     <v-chip small dark class="mt-2" :color="endorsementColor(memberinfo.applcorp_proposer_status)">
                        {{ endorsementLabel(memberinfo.applcorp_proposer_status) }}
                     </v-chip>
                     <div v-if="memberinfo.applcorp_proposer_responded_at" class="caption mt-1">
                        Responded: {{ formatDate(memberinfo.applcorp_proposer_responded_at) }}
                     </div>
                  </v-card-text></v-card>
               </v-col>
               <v-col cols="12" md="6">
                  <v-card outlined><v-card-text class="py-3">
                     <div class="caption grey--text mb-1">Seconder</div>
                     <div class="body-2 font-weight-medium">{{ seconder ? seconder.fullname : 'Not assigned' }}</div>
                     <div v-if="seconder" class="caption grey--text">{{ seconder.memberid || '-' }} ({{ seconder.membertype }})</div>
                     <v-chip small dark class="mt-2" :color="endorsementColor(memberinfo.applcorp_seconder_status)">
                        {{ endorsementLabel(memberinfo.applcorp_seconder_status) }}
                     </v-chip>
                     <div v-if="memberinfo.applcorp_seconder_responded_at" class="caption mt-1">
                        Responded: {{ formatDate(memberinfo.applcorp_seconder_responded_at) }}
                     </div>
                  </v-card-text></v-card>
               </v-col>
            </v-row>

            <v-form><v-row dense>
               <v-col cols="12" md="4"><v-text-field v-model="form.course_date" label="Course Date" type="date" outlined dense></v-text-field></v-col>
               <v-col cols="12" md="4"><v-text-field v-model="form.interview_date" label="Interview Date" type="date" outlined dense></v-text-field></v-col>
               <v-col cols="12" md="4"><v-text-field v-model="form.exam_date" label="Exam Date" type="date" outlined dense></v-text-field></v-col>
               <v-col cols="12"><v-textarea v-model="form.notes" label="Admin Notes" outlined rows="3"></v-textarea></v-col>
               <v-col cols="12">
                  <v-file-input v-model="form.document" label="Replace Support Document" accept=".jpg,.jpeg,.png,.pdf" outlined dense show-size></v-file-input>
                  <v-btn v-if="memberinfo.applcorp_document" text small color="primary" :href="documentUrl" target="_blank"><v-icon left small>mdi-file-document-outline</v-icon>View current document</v-btn>
               </v-col>
            </v-row></v-form>
         </v-card-text>
         <v-card-actions>
            <v-btn text href="/admin/corporate-upgrades">Back</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" :loading="saving" @click="save">Save Upgrade Info</v-btn>
            <v-btn v-if="status===3" color="orange darken-2" dark :loading="reopening" @click="reopen">
               <v-icon left>mdi-restore</v-icon>Reopen Application
            </v-btn>
            <v-btn v-if="status===1&&bothEndorsed" color="success" dark @click="approve">Approve</v-btn>
            <v-btn v-if="status===1&&!bothEndorsed" color="success" dark disabled title="Waiting for proposer and seconder approval">Approve</v-btn>
            <v-btn v-if="[1,2,4].includes(status)" color="error" dark @click="reject">{{ status===2?'Management Reject':'Reject' }}</v-btn>
         </v-card-actions>
      </v-card>
   </v-container></dashboard-layout>
</template>
<script>
import DashboardLayout from '@/Layouts/DashboardLayout.vue'; import BaseBreadcrumb from '@/components/BaseBreadcrumb.vue'
export default{name:'MOACorporateUpgradeInfo',components:{DashboardLayout,BaseBreadcrumb},
props:{
   memberinfo:{type:Object,required:true},
   proposer:{type:Object,default:null},
   seconder:{type:Object,default:null},
},
data(){const date=v=>v?String(v).slice(0,10):'';return{page:{title:'Corporate Upgrade Information'},breadcrumbs:[{text:'Dashboard',disabled:false,to:'/dashboard'},{text:'Corporate Applications',disabled:false,to:'/admin/corporate-upgrades'},{text:'Information',disabled:true}],saving:false,reopening:false,form:{course_date:date(this.memberinfo.applcorp_course_date),interview_date:date(this.memberinfo.applcorp_interview_date),exam_date:date(this.memberinfo.applcorp_exam_date),notes:this.memberinfo.applcorp_notes||'',document:null}}},
computed:{
   status(){return parseInt(this.memberinfo.applcorpstatus||0)},
   statusLabel(){return({1:'Pending Review',2:'Approved',3:'Rejected',4:'Need Resubmission'})[this.status]||'Not Submitted'},
   statusColor(){return({1:'orange darken-2',2:'green',3:'red',4:'deep-purple'})[this.status]||'grey'},
   flash(){return(this.$page&&(this.$page.props||this.$page).flash)||{}},
   documentUrl(){return`/${this.memberinfo.applcorp_documentpath}/${this.memberinfo.applcorp_document}`},
   profilePhotoSrc(){return this.memberinfo.userid?`/member/photo/${this.memberinfo.userid}?v=${Date.now()}`:''},
   bothEndorsed(){return parseInt(this.memberinfo.applcorp_proposer_status||0)===1&&parseInt(this.memberinfo.applcorp_seconder_status||0)===1},
},
methods:{
   endorsementLabel(value){return({0:'Pending',1:'Approved',2:'Rejected'})[parseInt(value||0)]||'Pending'},
   endorsementColor(value){return({0:'orange darken-2',1:'green',2:'red'})[parseInt(value||0)]||'orange darken-2'},
   formatDate(value){if(!value)return'-';return new Date(value).toLocaleDateString('en-MY',{day:'2-digit',month:'2-digit',year:'numeric'})},
   save(){const d=new FormData();d.append('userid',this.memberinfo.userid);['course_date','interview_date','exam_date','notes'].forEach(k=>d.append(k,this.form[k]||''));if(this.form.document)d.append('document',this.form.document);this.saving=true;this.$inertia.post('/admin/member/upgrade-corporate/update-info',d,{preserveScroll:true,onFinish:()=>{this.saving=false}})},
   approve(){if(confirm('Approve this Corporate Upgrade application?'))this.$inertia.post('/admin/member/upgrade-corporate/approve',{userid:this.memberinfo.userid})},
   reject(){if(confirm('Reject this Corporate Upgrade application?'))this.$inertia.post('/admin/member/upgrade-corporate/reject',{userid:this.memberinfo.userid})},
   reopen(){if(confirm('Reopen this Corporate Upgrade application? Member will be able to resubmit.')){this.reopening=true;this.$inertia.post('/admin/member/upgrade-corporate/reopen',{userid:this.memberinfo.userid},{onFinish:()=>{this.reopening=false}})}}
}}
</script>
<style scoped>.applicant{border-left:4px solid #1976d2!important}</style>